







































































































import _ from 'lodash';
import { recognition, AccountType } from 'mycorems-app-accounts';
import { Loader } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { AccountSettings, Account } from '@/types';
import { HasTaskMixin } from '@/mixins';
import eventBus from '@/messaging/event-bus';
import { ClientSetup } from '@/messaging/events';
import { update } from './account-settings';
import repository from './account-settings-repository';
import accountRepository from '../account/account-repository';

interface Data {
  accountSettings: AccountSettings|null,
  account: Account|null,
  accountTask: Promise<Account>|null,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    visibleSettings: {
      type: Array as () => String[],
      default() {
        return [];
      },
    },
  },
  data(): Data {
    return {
      accountSettings: null,
      account: null,
      accountTask: null,
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
    accountSettings: {
      handler(): void {
        this.updateSettings();
      },
      deep: true,
    },
  },
  computed: {
    fetchPeriodSuffix(): string {
      if (!this.accountSettings) return 'days';
      return (this.accountSettings.fetchPeriod > 1) ? 'days' : 'day';
    },
    isClient(): boolean {
      return recognition.isClient();
    },
    visibleAccountSettings(): String[] {
      if (!_.isEmpty(this.visibleSettings)) return this.visibleSettings;
      if (!this.account) return [''];
      if ((this.account.type === AccountType.CLIENT) && !recognition.isClient()) {
        return ['autoReportGenerate', 'apiKey', 'notifyClientReportGenerated'];
      }
      return ['autoReportGenerate', 'apiKey'];
    },
  },
  methods: {
    updateSettings(): void {
      if (!this.accountSettings) return;
      this.task = update(this.accountSettings);
    },
    load(): void {
      this.loadAccount();
      this.loadSettings();
    },
    loadSettings(): void {
      this.task = repository.find(this.accountId);
      this.task.then((accountSettings: AccountSettings) => {
        this.accountSettings = accountSettings;
      });
    },
    loadAccount(): void {
      this.accountTask = accountRepository.find(this.accountId);
      this.accountTask.then((account: Account) => {
        this.account = account;
      });
    },
    isGranted,
  },
  created(): void {
    this.load();
    eventBus.$on(ClientSetup.eventName, this.load);
  },
  beforeDestroy(): void {
    eventBus.$off(ClientSetup.eventName, this.load);
  },
  components: {
    loader: Loader,
  },
});
